import callsApi from '@/api/clientCalls';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    clientCalls:null
}

export const mutationTypes = {
    clientCallsStart: '[calls] Client calls start',
    clientCallsSuccess: '[calls] Client calls success',
    clientCallsFailure: '[calls] Client calls failure',
}

export const callsActionTypes = {
    clientCalls: '[calls] Client calls',
}

const mutations = {
    [mutationTypes.clientCallsStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.clientCallsSuccess](state, payload) {
        state.isLoading = false
        state.clientCalls = payload
        state.validationErrors = null
    },
    [mutationTypes.clientCallsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

}

const actions = {
    [callsActionTypes.clientCalls](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.clientCallsStart)
            callsApi
                .clientCalls(data)
                .then(response => {
                    context.commit(mutationTypes.clientCallsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.clientCallsFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}